var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3246 13.1026C12.8658 12.7436 12.356 12.5833 11.8174 12.5833C10.4456 12.5833 9.37013 13.6584 9.37013 15.0298V16.2243L14.2646 20.0437V13.8352L13.3246 13.1026Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.737 15.0298C38.737 13.6584 37.6616 12.5833 36.2898 12.5833C35.7512 12.5833 35.2413 12.7436 34.7826 13.1026L33.8425 13.8352V20.0437L38.737 16.2243V15.0298Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0536 21.4707L17.5276 16.3804V22.592L24.0536 27.6888L30.5795 22.592V16.3804L24.0536 21.4707Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2646 35.4167V24.1816L9.37013 20.3622V33.7857C9.37013 34.7073 10.0798 35.4167 11.0016 35.4167H14.2646Z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.737 33.7857V20.3622L33.8425 24.1816V35.4167H37.1055C38.0274 35.4167 38.737 34.7073 38.737 33.7857Z",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8571 0H5.14286C2.30357 0 0 2.30357 0 5.14286V42.8571C0 45.6964 2.30357 48 5.14286 48H42.8571C45.6964 48 48 45.6964 48 42.8571V5.14286C48 2.30357 45.6964 0 42.8571 0ZM6.10714 15.0298C6.10714 11.8964 8.68296 9.32143 11.8174 9.32143C13.0398 9.32143 14.2904 9.71788 15.3321 10.5319H15.3353L24.0536 17.3328L32.7719 10.5319C33.8141 9.71654 35.0664 9.32143 36.2898 9.32143C39.4242 9.32143 42 11.8964 42 15.0298V33.7857C42 36.4686 39.7893 38.6786 37.1055 38.6786H30.5795V26.7299L24.0536 31.8267L17.5276 26.7299V38.6786H11.0016C8.31787 38.6786 6.10714 36.4686 6.10714 33.7857V15.0298Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeGmail);
export default __webpack_public_path__ + "static/media/icone-gmail.83d87c8e9320efb1061dfffd2794508e.svg";
export { ForwardRef as ReactComponent };